import type {AbstractSketchEdgeObject} from '../../../../mesh/sketch/AbstractSketchEdgeObject';
import {SketchRelationKind} from '../../../../sketch/solver/constraint/relation-compatibility';
import {SingleTargetRelation} from '../../../../sketch/solver/constraint/relationDefinition/SingleTargetRelation';
import {resolvePreferredEdgeLabel} from '../../model/EdgeLabelUtils';

/**
 * 转换实体引用计算失败后的瞬态诊断关系。
 *
 * 该关系不参与求解和持久化，只让保留的旧投影在关系面板中明确显示“失败”。
 */
export class FailedSketchEntityReferenceConstraint
	extends SingleTargetRelation<AbstractSketchEdgeObject> {
	/** 标记该关系只属于派生诊断。 */
	public override readonly isTransientDiagnosticConstraint = true;
	/** 引用记录稳定 ID。 */
	public readonly referenceId: string;
	/** 仍以 SolidWorks 的 On Edge 关系语义展示。 */
	public relationType = SketchRelationKind.OnEdge;

	/**
	 * @param referenceId 引用记录稳定 ID。
	 * @param diagnosticMessage 当前失败原因。
	 * @param sourceDisplayLabel 持久化来源显示标签。
	 */
	public constructor(
		referenceId: string,
		diagnosticMessage: string,
		sourceDisplayLabel?: string,
	) {
		super();
		this.referenceId = referenceId;
		this.name = resolvePreferredEdgeLabel({
			persistedSourceDisplayLabel: sourceDisplayLabel,
		});
		// 复用既有 dangling 求解隔离语义，保证瞬态失败关系永不进入参数公式。
		this.markDangling(diagnosticMessage);
		this.markFailed(diagnosticMessage);
	}

	/** @returns 关系面板使用的稳定显示名。 */
	public override get baseDisplayName(): string {
		return this.name;
	}
}
